import PropTypes from 'prop-types';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
function CrmTicketLink({
  objectId,
  onClick,
  portalId,
  objectName
}) {
  const ticketHref = `/contacts/${portalId}/ticket/${objectId}`;
  const ticketName = objectName || `#${objectId}`;
  return /*#__PURE__*/_jsx(Link, {
    marginInlineStart: "100",
    href: ticketHref,
    onClick: onClick,
    external: true,
    children: ticketName
  });
}
CrmTicketLink.displayName = 'CrmTicketLink';
CrmTicketLink.propTypes = {
  objectId: PropTypes.number.isRequired,
  objectName: PropTypes.node,
  onClick: PropTypes.func,
  portalId: PropTypes.number.isRequired
};
export default CrmTicketLink;